<template lang='pug'>
  .spinner(:class='{"dark-spinner": dark, "light-spinner": !dark}')
    .bounce1
    .bounce2
    .bounce3
</template>

<script>
// TODO: for when you want to adjust things:
// http://epic-spinners.epicmax.co/?ref=producthunt#/get-started
export default {
  name: 'BionicMetricsRunningIndicator',
  components: {},
  props: {
    dark: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .spinner > div {
    width: 1vmin;
    height: 1vmin;
    border-radius: 100%;
    background-color: pink;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }

  .spinner.dark-spinner > div {
    background-color: #FAFAFA;
  }

  .spinner.light-spinner > div {
    background-color: #455A64;
  }

  .spinner .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  .spinner .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  @-webkit-keyframes sk-bouncedelay {
    0%, 80%, 100% {
      -webkit-transform: scale(0)
    }
    40% {
      -webkit-transform: scale(1.0)
    }
  }

  @keyframes sk-bouncedelay {
    0%, 80%, 100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1.0);
      transform: scale(1.0);
    }
  }
</style>
